import Thumbnail1 from './images/blog1.jpg'
import Thumbnail2 from './images/blog2.jpg'
import Thumbnail3 from './images/blog3.jpg'
import Thumbnail4 from './images/blog4.jpg'



export const DUMMY_POSTS = [

    {
        id: '1',
        thumbnail: Thumbnail1,
        category: 'education',
        title: 'This is the title of the first post on this blog',
        desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry w to make a type specimen book. It has survived not only five centuries',
        authorID: 3
    },


    {
        id: '2',
        thumbnail: Thumbnail2,
        category: 'Science',
        title: 'Welcome To Pakistan',
        desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry w to make a type specimen book. It has survived not only five centuries',
        authorID: 1
    },

    {
        id: '3',
        thumbnail: Thumbnail3,
        category: 'weather',
        title: 'This is the title of the first post on this blog',
        desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry w to make a type specimen book. It has survived not only five centuries',
        authorID: 13
    },

    {
        id: '4',
        thumbnail: Thumbnail4,
        category: 'farming',
        title: 'This is the title of the first post on this blog',
        desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry w to make a type specimen book. It has survived not only five centuries',
        authorID: 11
    }
]
